import {Component, inject, OnInit} from "@angular/core";
import {CommonModule, DatePipe} from "@angular/common";
import {TranslatePipe} from "../../filters/translate.pipe";
import {AvatarComponent} from "../../components/avatar/avatar.component";
import {ListLanguageFlagsComponent} from "../../components/list-language-flags/list-language-flags.component";
import {ItemRatingComponent} from "../../components/item-rating/item-rating.component";
import {FormsModule} from "@angular/forms";
import {LoaderOverlayComponent} from "../../components/loader-overlay/loader-overlay.component";
import RestService from "../../services/core-rest.service";
import Session from "../../utils/session.service";
import AngularHelperService from "../../services/angular-helper.service";
import RoutingService from "../../services/routing.service";
import Config from "../../utils/config.service";

@Component({
    standalone: true,
    selector: 'sp-feedbacks',
    templateUrl: './sp-feedbacks.component.html',
    imports: [
        CommonModule, DatePipe,
        TranslatePipe, AvatarComponent,
        ListLanguageFlagsComponent, ItemRatingComponent, FormsModule,
        LoaderOverlayComponent
    ]
})

export default class SpFeedbacksView implements OnInit {
    private restService: RestService = inject(RestService);
    private session: Session = inject(Session);
    private angularHelperService: AngularHelperService = inject(AngularHelperService);
    private config: Config = inject(Config);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        this.onResolve();
    }

    onResolve() {
        this.vm.user = this.session.getSession().user;
        this.vm.pageSize = 6;
        this.vm.feedbacks = [];
        this.vm.hasMoreFeedback = false;
        this.vm.filter = {
            orderBy: 'created',
            ascending: false
        };
        this.vm.getFeedbacks = this.getFeedbacks;
        this.getFeedbacks(true, true);
    }

    getFeedbacks(isInitial = false, hasLoader = false) {
        if (isInitial) {
            this.vm.endReached = false;
            this.vm.feedbacks = [];
            this.vm.currentPage = 0;
        }

        if (this.vm.endReached) {
            this.vm.loading = false;
            return;
        }

        this.vm.loading = true;

        const params: any = {
            pageSize: this.vm.pageSize,
            start: this.vm.currentPage * this.vm.pageSize,
            orderBy: this.vm.filter?.orderBy || 'created',
            ascending: this.vm.filter?.ascending || false,
            serviceProviderId: this.vm.user.id
        };

        this.restService.getServiceProviderFeedbacks(params, (feedbacks) => {
            if (!feedbacks || feedbacks.length < this.vm.pageSize) {
                this.vm.endReached = true;
            }

            const newFeedbacks = isInitial ? feedbacks : this.vm.feedbacks.concat(feedbacks);

            if (hasLoader) {
                this.angularHelperService.createTimer(() => {
                    this.vm.feedbacks = newFeedbacks;
                    this.vm.loading = false;
                }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
            } else {
                this.vm.feedbacks = newFeedbacks;
                this.vm.loading = false;
            }

            this.vm.currentPage++;
        });
    }
}